import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AddContestPage from "../Modals/Contest/AddContest";
import EditContestPage from "../Modals/Contest/EditContest";
import { FaEye, FaPlay, FaPlayCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
const TrainersContestVideo = () => {
  const [contests, setEvents] = useState([]);
  const [showAddEventPopup, setShowAddEventPopup] = useState(false);
  const [showEditEventPopup, setShowEditEventPopup] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [selectedVideoLink, setSelectedVideoLink] = useState(null);
  const [contestsVideo, setVideoContests] = useState([]);
  const [members, setMember] = useState([]);
  const navigate = useNavigate();
  const { contestId } = useParams();
  const transformToEmbedUrl = (url) => {
    // YouTube Embed
    if (url.includes("youtube.com/shorts/")) {
      const videoId = url.split("/shorts/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    if (url.includes("youtube.com/watch?v=")) {
      const videoId = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Handle YouTube short URL (youtu.be format)
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Vimeo Embed
    if (url.includes("vimeo.com/")) {
      const videoId = url.split("vimeo.com/")[1];
      return `https://player.vimeo.com/video/${videoId}`;
    }

    // Dailymotion Embed
    if (url.includes("dailymotion.com/video/")) {
      const videoId = url.split("dailymotion.com/video/")[1].split("_")[0];
      return `https://www.dailymotion.com/embed/video/${videoId}`;
    }

    // Instagram Embed (Posts only, not reels or videos)
    if (url.includes("instagram.com/p/")) {
      const shortcode = url.split("instagram.com/p/")[1].split("/")[0];
      return `https://www.instagram.com/embed/${shortcode}`;
    }

    // Instagram Video or Reel: Open in a new tab
    if (
      url.includes("instagram.com/reel/") ||
      url.includes("instagram.com/tv/")
    ) {
      window.open(url, "_blank");
      return null; // Return null to indicate no embed URL
    }

    // Facebook Video: Open in a new tab
    if (
      url.includes("facebook.com/watch/") ||
      url.includes("facebook.com/video/")
    ) {
      window.open(url, "_blank");
      return null; // Return null to indicate no embed URL
    }

    // Return original URL if no match
    return url;
  };

  const handleViewDetailsClick = (contestId) => {
    // Navigate to the detail page with the contest ID
    navigate(`/trainersContestVideo/${contestId}`);
  };

  const handleVideoClick = (link) => {
    const embedLink = transformToEmbedUrl(link);
    setSelectedVideoLink(embedLink); // Set the transformed embed link
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleAddEventClick = () => {
    setShowAddEventPopup(true);
  };

  const handleEditEventClick = (contest) => {
    setCurrentEvent(contest);
    setShowEditEventPopup(true);
  };

  const handleDeleteEventClick = async (contestId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this contest!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`/contests/delete/${contestId}`);
        Swal.fire("Deleted!", "The contest has been deleted.", "success");
        fetchEvents();
      } catch (err) {
        Swal.fire("Error!", "Failed to delete the contest.", "error");
      }
    } else {
      Swal.fire("Cancelled", "The contest was not deleted.", "info");
    }
  };

  const fetchContestsVideo = async () => {
    try {
      const response = await axios.get("/contests/get_all_video");
      setVideoContests(response.data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  const fetchMember = async () => {
    try {
      const response = await axios.get("/member/get_all_member");
      setMember(response.data);
    } catch (error) {
      console.error("Error fetching member:", error);
    }
  };

  const fetchEvents = async () => {
    try {
      const response = await axios.get("/contests/get_all");
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };

  useEffect(() => {
    fetchEvents();
    fetchContestsVideo();
    fetchMember();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">
              {contests.map((contest) =>
                // Check if contest.id matches contestId
                contest.contest_id.toString() === contestId ? (
                  <span key={contest.id}>{contest.contest_title}</span>
                ) : null
              )}
            </h1>
          </div>
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border px-4 py-2 w-30">Member ID</th>
                <th className="border px-4 py-2">Name</th>
                <th className="border px-4 py-2">Video Link</th>
              </tr>
            </thead>
            <tbody>
              {contestsVideo.map((contest) =>
                contest.contest_id.toString() === contestId ? (
                  <tr key={contest.id}>
                    <td className="border px-4 py-2">
                      {contest.jci_member_id}
                    </td>

                  {/* Find the member that matches the contest's jci_member_id */}
                  <td className="border px-4 py-2">
                {members && members.length > 0 ? (
                  <>
                    
                    <span>
                      {members.some((m) => String(m.member_id) === String(contest.jci_member_id)) ? (
                        members
                          .filter((m) => String(m.member_id) === String(contest.jci_member_id))
                          .map((m) => (
                            <span key={m.member_id}>
                              {m.name ? m.name : "Name not available"}
                            </span>
                          ))
                      ) : (
                        "N/A"
                      )}
                    </span>
                  </>
                ) : (
                  "N/A"
                )}
              </td>









                    <td className="border px-4 py-2">
                      {contest.video_link ? (
                        <a
                          onClick={() => handleVideoClick(contest.video_link)}
                          className="text-red-700 text-3xl underline hover:text-red-900"
                        >
                          <FaPlayCircle />
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>

          {/* Modal or Section to Display the Video */}
          {selectedVideoLink && (
            <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
              <div className="bg-white p-5 rounded-lg shadow-lg">
                <iframe
                  width="560"
                  height="315"
                  src={selectedVideoLink}
                  title="Video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <button
                  onClick={() => setSelectedVideoLink(null)}
                  className="mt-2 px-4 py-2 bg-gray-600 text-white rounded-lg"
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {showAddEventPopup && (
            <AddContestPage
              onClose={() => setShowAddEventPopup(false)}
              onSubmit={fetchEvents}
            />
          )}

          {showEditEventPopup && currentEvent && (
            <EditContestPage
              contestId={currentEvent.contest_id} // Pass contestId here
              onClose={() => setShowEditEventPopup(false)}
              onSubmit={fetchEvents}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TrainersContestVideo;
